class Currency {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._select = elem.querySelector('select')
        this._form = elem.querySelector('form')
    }
    onInit () {
        this._select.addEventListener('change', e => {
            this._form.submit()
        })
    }
}

export default Currency



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Currency.js